import { useState, useEffect } from "react";
// v2.1 — licence dz/fr/eu
const API = process.env.REACT_APP_API_URL || "http://localhost:8000";

const APPRECIATIONS = ["", "Intéressé", "Pas intéressé", "Prolonger période d'essai", "Demande de devis"];

export default function AdminPanel({ onClose, fullPage = false }) {
  const [users, setUsers]         = useState([]);
  const [loading, setLoading]     = useState(true);
  const [erreur, setErreur]       = useState("");
  const [succes, setSucces]       = useState("");
  const [onglet, setOnglet]       = useState("liste");
  const [form, setForm]           = useState({ email:"", nom:"", prenom:"", entreprise:"", mobile:"", jours_essai:30, licence:"fr", password:"", copilote_mode:"off" });
  const [showPwd, setShowPwd]     = useState(false);
  const [pwdGenere, setPwdGenere] = useState("");

  const GV = {
    vert:"#2D7A2D", vertClair:"#00A651", vertLight:"#E8F5E9",
    dark:"#1A1A1A", gris:"#F8F9FA", grisMid:"#6B7280",
    border:"#E5E7EB", blanc:"#FFFFFF", rouge:"#DC2626", rougeLight:"#FEF2F2",
    orange:"#E8601A", orangeLight:"#FFF3ED",
  };

  const token = () => localStorage.getItem("geo5_token");

  const chargerUsers = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/admin/users`, { headers: { Authorization: `Bearer ${token()}` } });
      if (!res.ok) throw new Error();
      setUsers(await res.json());
    } catch {
      setErreur("Impossible de charger les utilisateurs.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { chargerUsers(); }, []);

  const creerUser = async (e) => {
    e.preventDefault();
    setErreur(""); setSucces("");
    try {
      const res = await fetch(`${API}/admin/users`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (!res.ok) { setErreur(data.detail); return; }
      setPwdGenere(data.password_genere);
      setSucces(`Compte créé pour ${form.email}`);
      setForm({ email:"", nom:"", prenom:"", entreprise:"", mobile:"", jours_essai:30, licence:"fr", password:"", copilote_mode:"off" });
      chargerUsers();
    } catch {
      setErreur("Erreur lors de la création.");
    }
  };

  const genererMagicLink = async (user) => {
    try {
      const res = await fetch(`${API}/admin/users/${user.id}/magic-link`, {
        headers: { Authorization: `Bearer ${token()}` },
      });
      const data = await res.json();
      if (!res.ok) { alert("Erreur : " + data.detail); return; }
      await navigator.clipboard.writeText(data.magic_link);
      alert(`🔗 Lien magique copié !\n\nEnvoyez ce lien à ${user.nom} ${user.prenom} :\n\n${data.magic_link}\n\n⚠️ Valable 30 jours — ne pas partager.`);
    } catch {
      alert("Erreur lors de la génération du lien.");
    }
  };

  const toggleActif = async (user) => {
    await fetch(`${API}/admin/users/${user.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ is_active: !user.is_active }),
    });
    chargerUsers();
  };

  const prolonger = async (user, jours) => {
    await fetch(`${API}/admin/users/${user.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ jours_essai: jours }),
    });
    chargerUsers();
  };

  const changerAppreciation = async (user, appreciation) => {
    await fetch(`${API}/admin/users/${user.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ appreciation }),
    });
    chargerUsers();
  };

  const changerCoPilote = async (user, mode) => {
    // mode: "off" | "solution" | "complet"
    await fetch(`${API}/admin/users/${user.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify({
        has_copilote: mode !== "off",
        copilote_mode: mode === "off" ? "solution" : mode,
      }),
    });
    chargerUsers();
  };

  const copiloteMode = (u) => {
    if (!u.has_copilote) return "off";
    return u.copilote_mode || "solution";
  };

  const COPILOTE_OPTS = [
    { id:"off",      label:"🔒 OFF",      bg:"#F3F4F6", color:"#6B7280", border:"#D1D5DB" },
    { id:"solution", label:"🧭 Solution", bg:"#FFF7ED", color:"#D97706", border:"#D97706" },
    { id:"complet",  label:"🧭 Complet",  bg:"#ECFDF5", color:"#059669", border:"#059669" },
  ];

  const changerLicence = async (user, licence) => {
    await fetch(`${API}/admin/users/${user.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ licence }),
    });
    chargerUsers();
  };

  const LICENCES = [
    { id:"fr", label:"🇫🇷 GeoExpert_fr", desc:"France — EC7/EC8 — EUR",  bg:"#EFF6FF", color:"#2563EB" },
    { id:"eu", label:"🌍 GeoExpert_eu", desc:"Europe — Eurocode — EUR",   bg:"#F5F3FF", color:"#7C3AED" },
  ];
  const licenceBadge = (lic) => LICENCES.find(l => l.id === (lic||"fr")) || LICENCES.find(l => l.id === "fr");

  const toggleCopyright = async (user) => {
    await fetch(`${API}/admin/users/${user.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${token()}` },
      body: JSON.stringify({ copyright_accepted: !user.copyright_accepted }),
    });
    chargerUsers();
  };

  const supprimer = async (user) => {
    if (!window.confirm(`Supprimer le compte de ${user.email} ?`)) return;
    await fetch(`${API}/admin/users/${user.id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${token()}` },
    });
    chargerUsers();
  };

  const statutBadge = (u) => {
    if (!u.is_active) return { label:"Désactivé", bg:"#F3F4F6", color:"#6B7280" };
    if (u.expire) return { label:"Expiré", bg:GV.rougeLight, color:GV.rouge };
    if (u.jours_restants !== null && u.jours_restants <= 5) return { label:`⚠️ ${u.jours_restants}j`, bg:GV.orangeLight, color:GV.orange };
    if (u.jours_restants !== null) return { label:`${u.jours_restants}j restants`, bg:GV.vertLight, color:GV.vert };
    return { label:"Permanent", bg:"#EFF6FF", color:"#2563EB" };
  };

  const appreciationColor = (a) => {
    if (a === "Intéressé") return { bg:"#ECFDF5", color:"#059669" };
    if (a === "Pas intéressé") return { bg:"#FEF2F2", color:"#DC2626" };
    if (a === "Prolonger période d'essai") return { bg:"#FFF7ED", color:"#D97706" };
    if (a === "Demande de devis") return { bg:"#EFF6FF", color:"#2563EB" };
    return { bg:"#F3F4F6", color:"#6B7280" };
  };

  const wrapperStyle = fullPage
    ? { minHeight:"100vh", background:"#f1f5f9", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"flex-start", padding:"32px 16px", fontFamily:"'Segoe UI', system-ui, sans-serif" }
    : { position:"fixed", inset:0, background:"rgba(0,0,0,0.7)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:9999, padding:16, fontFamily:"'Segoe UI', system-ui, sans-serif" };

  const panelStyle = fullPage
    ? { background:GV.blanc, borderRadius:20, width:"100%", maxWidth:1100, overflow:"hidden", display:"flex", flexDirection:"column", boxShadow:"0 8px 40px rgba(0,0,0,0.12)" }
    : { background:GV.blanc, borderRadius:20, width:"100%", maxWidth:1000, maxHeight:"92vh", overflow:"hidden", display:"flex", flexDirection:"column", boxShadow:"0 24px 80px rgba(0,0,0,0.4)" };

  return (
    <div style={wrapperStyle}>
      <div style={panelStyle}>

        {/* Header */}
        <div style={{ background:`linear-gradient(135deg,${GV.vert},${GV.vertClair})`, padding:"20px 28px", display:"flex", alignItems:"center", justifyContent:"space-between" }}>
          <div>
            <div style={{ color:"rgba(255,255,255,0.8)", fontSize:11, fontWeight:700, letterSpacing:2, marginBottom:4 }}>CIVISOFT — PANNEAU ADMINISTRATEUR</div>
            <div style={{ color:"#fff", fontSize:18, fontWeight:800 }}>⚙️ Gestion des licences GEO5 Expert Advisor</div>
          </div>
          <button onClick={onClose} style={{ background:"rgba(255,255,255,0.15)", border:"1px solid rgba(255,255,255,0.3)", color:"#fff", borderRadius:8, padding:"8px 16px", cursor:"pointer", fontSize:13, fontWeight:600 }}>
            {fullPage ? "⏏ Déconnexion" : "✕"}
          </button>
        </div>

        {/* Onglets */}
        <div style={{ display:"flex", gap:4, padding:"12px 28px 0", borderBottom:`1px solid ${GV.border}`, background:GV.gris }}>
          {[["liste","👥 Utilisateurs"],["creer","➕ Créer un accès"]].map(([id,label]) => (
            <button key={id} onClick={() => setOnglet(id)} style={{ padding:"9px 18px", border:"none", borderBottom: onglet===id ? `3px solid ${GV.vert}` : "3px solid transparent", background:"transparent", color: onglet===id ? GV.vert : GV.grisMid, fontWeight: onglet===id ? 700 : 400, cursor:"pointer", fontSize:13 }}>{label}</button>
          ))}
          <span style={{ marginLeft:"auto", alignSelf:"center", fontSize:12, color:GV.grisMid }}>{users.filter(u=>!u.is_admin).length} licence(s)</span>
        </div>

        {/* Contenu */}
        <div style={{ flex:1, overflowY:"auto", padding:28 }}>

          {erreur && <div style={{ background:GV.rougeLight, border:`1px solid ${GV.rouge}`, borderRadius:8, padding:"10px 14px", fontSize:13, color:GV.rouge, marginBottom:16 }}>⚠️ {erreur}</div>}
          {succes && (
            <div style={{ background:GV.vertLight, border:`1px solid ${GV.vert}`, borderRadius:8, padding:"12px 16px", fontSize:13, color:GV.vert, marginBottom:16 }}>
              ✅ {succes}
              {pwdGenere && <div style={{ marginTop:8, background:"#fff", borderRadius:6, padding:"8px 12px", fontFamily:"monospace", fontSize:14, fontWeight:700 }}>
                🔑 Mot de passe généré : <span style={{ color:GV.vert }}>{pwdGenere}</span>
                <span style={{ fontSize:11, color:GV.grisMid, marginLeft:12 }}>— Communiquez-le à l'utilisateur</span>
              </div>}
            </div>
          )}

          {/* ── LISTE UTILISATEURS ── */}
          {onglet === "liste" && (
            loading ? <div style={{ textAlign:"center", padding:40, color:GV.grisMid }}>Chargement...</div> :
            <div style={{ display:"flex", flexDirection:"column", gap:12 }}>
              {users.filter(u => !u.is_admin).map(u => {
                const badge = statutBadge(u);
                const apprColor = appreciationColor(u.appreciation);
                return (
                  <div key={u.id} style={{ border:`1.5px solid ${u.expire ? GV.rouge : u.is_active ? GV.border : "#D1D5DB"}`, borderRadius:14, padding:"16px 20px", background: u.expire ? GV.rougeLight : GV.blanc }}>

                    {/* Ligne 1 — infos */}
                    <div style={{ display:"flex", alignItems:"flex-start", gap:16, flexWrap:"wrap", marginBottom:12 }}>
                      <div style={{ flex:1, minWidth:220 }}>
                        <div style={{ fontWeight:700, fontSize:15, color:GV.dark }}>{u.prenom} {u.nom}</div>
                        <div style={{ fontSize:12, color:"#2563EB", fontWeight:600 }}>{u.email}</div>
                        {u.entreprise && <div style={{ fontSize:12, color:GV.grisMid, marginTop:2 }}>🏢 {u.entreprise}</div>}
                        {u.mobile && <div style={{ fontSize:12, color:GV.grisMid }}>📱 {u.mobile}</div>}
                      </div>
                      <div style={{ textAlign:"right" }}>
                        <span style={{ background:badge.bg, color:badge.color, borderRadius:6, padding:"4px 10px", fontSize:12, fontWeight:700 }}>{badge.label}</span>
                        {" "}
                        <span style={{ background:licenceBadge(u.licence).bg, color:licenceBadge(u.licence).color, borderRadius:6, padding:"4px 10px", fontSize:11, fontWeight:700 }}>{licenceBadge(u.licence).label}</span>
                        <div style={{ fontSize:11, color:GV.grisMid, marginTop:4 }}>
                          Créé le {new Date(u.date_creation).toLocaleDateString("fr-FR")}
                        </div>
                        {u.derniere_connexion && (
                          <div style={{ fontSize:11, color:GV.grisMid }}>
                            Connecté le {new Date(u.derniere_connexion).toLocaleDateString("fr-FR")}
                          </div>
                        )}
                        {u.date_expiration && (
                          <div style={{ fontSize:11, color:GV.grisMid }}>
                            Expire le {new Date(u.date_expiration).toLocaleDateString("fr-FR")}
                          </div>
                        )}
                        <div style={{ marginTop:6 }}>
                          <span style={{
                            background: u.copyright_accepted ? "#ECFDF5" : "#FEF2F2",
                            color: u.copyright_accepted ? "#059669" : "#DC2626",
                            borderRadius:6, padding:"3px 8px", fontSize:10, fontWeight:700
                          }}>
                            {u.copyright_accepted ? "✅ Conditions approuvées" : "⏳ En attente"}
                          </span>
                          {u.copyright_date && (
                            <div style={{ fontSize:10, color:GV.grisMid, marginTop:2 }}>
                              {new Date(u.copyright_date).toLocaleDateString("fr-FR")} à {new Date(u.copyright_date).toLocaleTimeString("fr-FR", { hour:"2-digit", minute:"2-digit" })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Ligne 2 — appréciation + actions */}
                    <div style={{ display:"flex", alignItems:"center", gap:8, flexWrap:"wrap" }}>
                      <select value={u.appreciation || ""} onChange={e => changerAppreciation(u, e.target.value)}
                        style={{ padding:"5px 10px", fontSize:12, border:`1.5px solid ${apprColor.color}`, borderRadius:6, background:apprColor.bg, color:apprColor.color, fontWeight:600, cursor:"pointer" }}>
                        {APPRECIATIONS.map(a => <option key={a} value={a}>{a || "— Appréciation —"}</option>)}
                      </select>
                      <div style={{ marginLeft:"auto", display:"flex", gap:6, flexWrap:"wrap" }}>
                        <button onClick={() => prolonger(u, 30)} style={{ padding:"5px 10px", fontSize:11, background:GV.vertLight, color:GV.vert, border:`1px solid ${GV.vert}`, borderRadius:6, cursor:"pointer", fontWeight:600 }}>+30j</button>
                        <button onClick={() => prolonger(u, 90)} style={{ padding:"5px 10px", fontSize:11, background:"#EFF6FF", color:"#2563EB", border:"1px solid #2563EB", borderRadius:6, cursor:"pointer", fontWeight:600 }}>+90j</button>
                        <select value={u.licence || "fr"} onChange={e => changerLicence(u, e.target.value)}
                          style={{ padding:"5px 8px", fontSize:11, border:`1.5px solid ${licenceBadge(u.licence).color}`, borderRadius:6, background:licenceBadge(u.licence).bg, color:licenceBadge(u.licence).color, fontWeight:700, cursor:"pointer" }}>
                          {LICENCES.map(l => <option key={l.id} value={l.id}>{l.label}</option>)}
                        </select>
                        <span style={{ fontSize:11, color:"#6B7280", fontWeight:600, alignSelf:"center" }}>Co-Pilote:</span>
                        {COPILOTE_OPTS.map(opt => (
                          <button key={opt.id} onClick={() => changerCoPilote(u, opt.id)}
                            style={{ padding:"5px 10px", fontSize:11, background: copiloteMode(u)===opt.id ? opt.bg : "#F9FAFB", color: copiloteMode(u)===opt.id ? opt.color : "#9CA3AF", border:`1.5px solid ${copiloteMode(u)===opt.id ? opt.border : "#E5E7EB"}`, borderRadius:6, cursor:"pointer", fontWeight: copiloteMode(u)===opt.id ? 700 : 400 }}>
                            {opt.label}
                          </button>
                        ))}
                        <button onClick={() => toggleCopyright(u)}
                          title={u.copyright_accepted ? `Approuvé le ${new Date(u.copyright_date).toLocaleDateString("fr-FR")}` : "Marquer comme approuvé manuellement"}
                          style={{ padding:"5px 10px", fontSize:11, background: u.copyright_accepted ? "#ECFDF5" : "#F3F4F6", color: u.copyright_accepted ? "#059669" : "#6B7280", border:`1px solid ${u.copyright_accepted ? "#059669" : "#D1D5DB"}`, borderRadius:6, cursor:"pointer", fontWeight:600 }}>
                          {u.copyright_accepted ? "✅ Cond." : "☐ Cond."}
                        </button>
                        <button onClick={() => genererMagicLink(u)} title="Générer un lien de connexion directe (sans mot de passe)" style={{ padding:"5px 10px", fontSize:11, background:"#EFF6FF", color:"#2563EB", border:"1px solid #93C5FD", borderRadius:6, cursor:"pointer", fontWeight:600 }}>🔗 Lien</button>
                        <button onClick={() => toggleActif(u)} style={{ padding:"5px 10px", fontSize:11, background: u.is_active ? GV.rougeLight : GV.vertLight, color: u.is_active ? GV.rouge : GV.vert, border:`1px solid ${u.is_active ? GV.rouge : GV.vert}`, borderRadius:6, cursor:"pointer", fontWeight:600 }}>{u.is_active ? "Désactiver" : "Activer"}</button>
                        <button onClick={() => supprimer(u)} style={{ padding:"5px 10px", fontSize:11, background:"#F3F4F6", color:"#6B7280", border:"1px solid #D1D5DB", borderRadius:6, cursor:"pointer" }}>🗑️</button>
                      </div>
                    </div>
                  </div>
                );
              })}
              {users.filter(u=>!u.is_admin).length === 0 && (
                <div style={{ textAlign:"center", padding:40, color:GV.grisMid }}>Aucun utilisateur. Créez le premier accès →</div>
              )}
            </div>
          )}

          {/* ── CRÉER UN UTILISATEUR ── */}
          {onglet === "creer" && (
            <form onSubmit={creerUser} style={{ maxWidth:520 }}>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
                <div>
                  <label style={{ fontSize:13, fontWeight:700, color:GV.dark, display:"block", marginBottom:6 }}>Prénom</label>
                  <input value={form.prenom} onChange={e => setForm(f=>({...f,prenom:e.target.value}))} placeholder="Prénom"
                    style={{ width:"100%", padding:"10px 13px", fontSize:14, border:`1.5px solid ${GV.border}`, borderRadius:8, outline:"none", boxSizing:"border-box" }}/>
                </div>
                <div>
                  <label style={{ fontSize:13, fontWeight:700, color:GV.dark, display:"block", marginBottom:6 }}>Nom</label>
                  <input value={form.nom} onChange={e => setForm(f=>({...f,nom:e.target.value}))} placeholder="Nom de famille"
                    style={{ width:"100%", padding:"10px 13px", fontSize:14, border:`1.5px solid ${GV.border}`, borderRadius:8, outline:"none", boxSizing:"border-box" }}/>
                </div>
              </div>
              <div style={{ marginBottom:16 }}>
                <label style={{ fontSize:13, fontWeight:700, color:GV.dark, display:"block", marginBottom:6 }}>Email *</label>
                <input type="email" required value={form.email} onChange={e => setForm(f=>({...f,email:e.target.value}))} placeholder="contact@entreprise.com"
                  style={{ width:"100%", padding:"10px 13px", fontSize:14, border:`1.5px solid ${GV.border}`, borderRadius:8, outline:"none", boxSizing:"border-box" }}/>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:16, marginBottom:16 }}>
                <div>
                  <label style={{ fontSize:13, fontWeight:700, color:GV.dark, display:"block", marginBottom:6 }}>Entreprise</label>
                  <input value={form.entreprise} onChange={e => setForm(f=>({...f,entreprise:e.target.value}))} placeholder="Bureau d'études..."
                    style={{ width:"100%", padding:"10px 13px", fontSize:14, border:`1.5px solid ${GV.border}`, borderRadius:8, outline:"none", boxSizing:"border-box" }}/>
                </div>
                <div>
                  <label style={{ fontSize:13, fontWeight:700, color:GV.dark, display:"block", marginBottom:6 }}>N° Mobile</label>
                  <input value={form.mobile} onChange={e => setForm(f=>({...f,mobile:e.target.value}))} placeholder="0555 XX XX XX"
                    style={{ width:"100%", padding:"10px 13px", fontSize:14, border:`1.5px solid ${GV.border}`, borderRadius:8, outline:"none", boxSizing:"border-box" }}/>
                </div>
              </div>
              <div style={{ marginBottom:20 }}>
                <label style={{ fontSize:13, fontWeight:700, color:GV.dark, display:"block", marginBottom:8 }}>Pack Licence *</label>
                <div style={{ display:"flex", gap:10 }}>
                  {LICENCES.map(l => (
                    <button key={l.id} type="button" onClick={() => setForm(f=>({...f,licence:l.id}))}
                      style={{ flex:1, padding:"10px 8px", border:`2px solid ${form.licence===l.id ? l.color : GV.border}`, borderRadius:10, background: form.licence===l.id ? l.bg : GV.blanc, color: form.licence===l.id ? l.color : GV.grisMid, fontWeight: form.licence===l.id ? 800 : 400, cursor:"pointer", fontSize:12, textAlign:"center" }}>
                      <div style={{ fontSize:16, marginBottom:3 }}>{l.label.split(" ")[0]}</div>
                      <div style={{ fontWeight:700 }}>{l.label.split(" ").slice(1).join(" ")}</div>
                      <div style={{ fontSize:10, marginTop:2, opacity:0.8 }}>{l.desc}</div>
                    </button>
                  ))}
                </div>
              </div>
              <div style={{ marginBottom:24 }}>
                <label style={{ fontSize:13, fontWeight:700, color:GV.dark, display:"block", marginBottom:6 }}>Période d'essai (jours)</label>
                <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:10 }}>
                  {[7,14,30,60,90].map(j => (
                    <button key={j} type="button" onClick={() => setForm(f=>({...f,jours_essai:j}))}
                      style={{ padding:"6px 14px", fontSize:12, fontWeight:form.jours_essai===j?700:400, background:form.jours_essai===j?GV.vert:"transparent", color:form.jours_essai===j?GV.blanc:GV.dark, border:`1.5px solid ${form.jours_essai===j?GV.vert:GV.border}`, borderRadius:6, cursor:"pointer" }}>
                      {j} jours
                    </button>
                  ))}
                </div>
                <input type="number" min="1" max="365" value={form.jours_essai} onChange={e => setForm(f=>({...f,jours_essai:parseInt(e.target.value)||30}))}
                  style={{ width:120, padding:"8px 12px", fontSize:14, border:`1.5px solid ${GV.border}`, borderRadius:8, outline:"none" }}/>
                <span style={{ fontSize:12, color:GV.grisMid, marginLeft:10 }}>
                  Expire le {new Date(Date.now() + form.jours_essai * 86400000).toLocaleDateString("fr-FR")}
                </span>
              </div>
              {/* Mot de passe */}
              <div style={{ marginBottom:20 }}>
                <label style={{ fontSize:13, fontWeight:700, color:GV.dark, display:"block", marginBottom:6 }}>Mot de passe</label>
                <div style={{ display:"flex", gap:8, alignItems:"center" }}>
                  <input type={showPwd ? "text" : "password"} value={form.password} onChange={e => setForm(f=>({...f,password:e.target.value}))} placeholder="Laisser vide = généré automatiquement"
                    style={{ flex:1, padding:"10px 13px", fontSize:14, border:`1.5px solid ${GV.border}`, borderRadius:8, outline:"none", boxSizing:"border-box" }}/>
                  <button type="button" onClick={() => setShowPwd(p=>!p)}
                    style={{ padding:"10px 14px", border:`1.5px solid ${GV.border}`, borderRadius:8, background:GV.gris, cursor:"pointer", fontSize:13 }}>
                    {showPwd ? "🙈" : "👁️"}
                  </button>
                </div>
                <div style={{ fontSize:11, color:GV.grisMid, marginTop:5 }}>
                  💡 Laisser vide → mot de passe généré automatiquement et affiché après création.
                </div>
              </div>

              {/* Co-Pilote */}
              <div style={{ marginBottom:24 }}>
                <label style={{ fontSize:13, fontWeight:700, color:GV.dark, display:"block", marginBottom:8 }}>Co-Pilote GEO5</label>
                <div style={{ display:"flex", gap:8 }}>
                  {COPILOTE_OPTS.map(opt => (
                    <button key={opt.id} type="button" onClick={() => setForm(f=>({...f, copilote_mode:opt.id, has_copilote: opt.id !== "off"}))}
                      style={{ flex:1, padding:"10px 8px", border:`2px solid ${form.copilote_mode===opt.id ? opt.border : GV.border}`, borderRadius:10, background: form.copilote_mode===opt.id ? opt.bg : GV.blanc, color: form.copilote_mode===opt.id ? opt.color : GV.grisMid, fontWeight: form.copilote_mode===opt.id ? 800 : 400, cursor:"pointer", fontSize:12, textAlign:"center" }}>
                      <div style={{ fontSize:16, marginBottom:3 }}>{opt.label.split(" ")[0]}</div>
                      <div>{opt.label.split(" ").slice(1).join(" ")}</div>
                      <div style={{ fontSize:10, marginTop:2, opacity:0.8 }}>
                        {opt.id === "off" ? "Pas d'accès" : opt.id === "solution" ? "Modules du projet" : "Tous les modules"}
                      </div>
                    </button>
                  ))}
                </div>
              </div>

              <button type="submit" style={{ padding:"12px 32px", background:`linear-gradient(135deg,${GV.vert},${GV.vertClair})`, border:"none", borderRadius:10, fontSize:14, fontWeight:800, color:GV.blanc, cursor:"pointer" }}>
                ➕ Créer le compte
              </button>
            </form>
          )}
        </div>

        {/* ── Info backend local ── */}
        <div style={{ margin:"24px 0 8px", padding:"12px 16px", background:"#fff8f0", border:"1px solid #f97316", borderRadius:10, fontSize:12, color:"#c2410c", lineHeight:1.8 }}>
          <div style={{ display:"flex", alignItems:"center", gap:8, marginBottom:4, fontWeight:800 }}>
            <span style={{ fontSize:9, border:"1px solid #16a34a", borderRadius:4, padding:"1px 5px", color:"#16a34a", fontWeight:800 }}>ADMIN</span>
            ℹ️ Backend local — développement
          </div>
          L'agent IA nécessite le backend FastAPI sur <code style={{ background:"rgba(232,96,26,0.15)", padding:"1px 4px", borderRadius:3 }}>localhost:8000</code><br/>
          Lancer : <code style={{ background:"rgba(232,96,26,0.15)", padding:"1px 4px", borderRadius:3 }}>python -m uvicorn main:app --reload --port 8000</code>
        </div>

      </div>
    </div>
  );
}
